//signUp.js
import request from '@/utils/request';

// 提交报名表
export function postRegistration(data) {
  return request({
    url: '/v1/user_info/registration_info',
    method: 'post',
    data: data,
  });
}

// 获取报名表信息
export function getRegistration(params) {
  return request({
    url: '/v1/user_info/registration_info',
    method: 'get',
    params: params,
  });
}

// 随行人员提交
export function postRetinue(data) {
  return request({
    url: '/v1/user_info/registration_retinue',
    method: 'post',
    data: data,
  });
}

// 编辑报名表
export function putRegistration(registration_id, data) {
  return request({
    url: '/v1/user_info/registration_info/' + registration_id,
    method: 'put',
    data: data,
  });
}
